import React, { useEffect, useState } from "react";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import TextInput from "../TextInput/TextInput";
import moment from "moment";

const DatePicker = ({
  value,
  handleChange = () => { },
  label,
  size = "medium",
  inputFormat = "DD/MM/YYYY",
  outputFormat = "YYYY-MM-DD",
  error,
  openTo = "year",
  views = ["year", "month", "day"],
  width = "100%",
  readOnly = false,
  ...props
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [open, setOpen] = useState(false);

  // Sync value
  useEffect(() => {
    if (value) {
      setSelectedDate(moment(value, outputFormat));
    } else {
      setSelectedDate(null);
    }
  }, [value, outputFormat]);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);

    if (newDate && moment(newDate).isValid()) {
      handleChange(moment(newDate).format(outputFormat));
    } else {
      handleChange(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiDatePicker
        open={readOnly ? false : open}
        onClose={() => setOpen(false)}
        onOpen={() => !readOnly && setOpen(true)}
        value={selectedDate}
        onChange={handleDateChange}
        views={views}
        openTo={openTo}
        format={inputFormat} // ⚠️ v5 uses `format` instead of inputFormat
        disabled={readOnly}
        {...props}
        label={label}
        slotProps={{
          textField: {
            fullWidth: true,
            size: size,
            error: error,
            sx: { width: width },
            InputProps: {
              readOnly: readOnly,
            },
            onClick: () => {
              if (!readOnly) setOpen(true);
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;